import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/notification/types'
import { EmptyUnreadPropsFactory, IUnreadProps } from '@/entities/Unread'

export default class NotificationRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set unread(value: IUnreadProps | null) {
    this.store.commit(new types.Unread({ ...EmptyUnreadPropsFactory(value) }))
  }

  get unread(): IUnreadProps | null {
    return { ...this.store.state.notification.unread }
  }

  talk(value: number) {
    const unread = this.store.state.notification.unread.talk + value
    this.store.commit(new types.Unread({ ...this.store.state.notification.unread, talk: unread < 0 ? 0 : unread }))
  }

  appointment(value: number) {
    const unread = this.store.state.notification.unread.appointment + value
    this.store.commit(new types.Unread({ ...this.store.state.notification.unread, appointment: unread < 0 ? 0 : unread }))
  }

  message(value: number) {
    const unread = this.store.state.notification.unread.message + value
    this.store.commit(new types.Unread({ ...this.store.state.notification.unread, message: unread < 0 ? 0 : unread }))
  }
}
